import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const submitLead = (payload) => api.post("/leads", payload).then((r) => r.data);

export const verifyAdmin = (token) =>
    api.post("/admin/verify", { token }).then((r) => r.data);

export const fetchLeads = (token) =>
    api.get("/leads", { headers: { "X-Admin-Token": token } }).then((r) => r.data);

export const deleteLead = (token, id) =>
    api.delete(`/leads/${id}`, { headers: { "X-Admin-Token": token } }).then((r) => r.data);
